<div class="wrapper">
  <div
    class="sidebar d-print-none"
    data-color="danger"
    data-background-color="white"
  >
    <app-sidebar></app-sidebar>
  </div>
  <div class="main-panel">
    <div
      *ngIf="showVersionUpgradeHint"
      class="upgrade-banner d-print-none"
      [class.upgrade-banner--info]="!showReloadButton"
    >
      <span class="upgrade-banner__text">
        <ng-container *ngIf="showReloadButton; else newestVersion">
          Es ist eine neue Version verfügbar.
        </ng-container>
        <ng-template #newestVersion>
          Sie nutzten jetzt die neueste Version.
        </ng-template>
        <a class="upgrade-banner__link" [href]="changelogLink" target="_blank" rel="noopener">
          Änderungen ansehen
        </a>
      </span>
      <button
        *ngIf="showReloadButton"
        class="upgrade-banner__reload"
        type="button"
        (click)="reloadApp()"
      >
        Neu laden
      </button>
      <button
        class="upgrade-banner__dismiss"
        type="button"
        (click)="closeVersionUpgradeHint()"
      >
        Hinweis ausblenden
      </button>
    </div>
    <app-navbar class="d-print-none"></app-navbar>
    <router-outlet></router-outlet>
    <div class="footer d-print-none">
      <div class="footer__bar">
        <div class="footer__links" *ngIf="(companySettings$ | async) as settings">
          <ng-container *ngIf="settings.imprintUrl">
            <a
              class="footer__link"
              [href]="settings.imprintUrl"
              target="_blank"
              rel="noopener"
              >Impressum</a
            >
          </ng-container>
          <ng-container *ngIf="settings.privacyUrl">
            <a
              class="footer__link"
              [href]="settings.privacyUrl"
              target="_blank"
              rel="noopener"
              >Datenschutz</a
            >
          </ng-container>
        </div><span class="footer__author">
          Powered by
          <a href="https://www.pegasustime.de" target="_blank">PegasusTime</a>
          <span class="footer__divider">|</span>
          <a
            [href]="'https://docs.gp2.app/changelog#' + frontendVersion"
            target="_blank"
            matTooltip="Änderungen"
            >{{ frontendVersion }}</a
          >
        </span>
      </div>
    </div>
  </div>
</div>
